// NOTE: 循環参照を防止するため、シングルトンインスタンスの保持を当ファイルへ集約し、当ファイル内ではtype以外をimportしない
import type {CHeliNetwork} from './networklib/CHeliNetwork';

export const singletonRegistry = {
  heliNetwork: null as CHeliNetwork | null
};

export const GetIHeliNetwork = (): CHeliNetwork | null => {
  return singletonRegistry.heliNetwork;
};
